<template>
    <Nodata :size="200" :type="2" class="auth-no-data">{{ errorMsg }}</Nodata>
</template>

<script>
export default {
    data() {
        return {
            errorMsg: '权限验证错误',
        };
    },
    created () {
        // 获取错误代码
        if (this.$route.params.error != undefined) {
            this.errorMsg = this.$route.params.error;
        }
    },
    methods: {
    }
};
</script>

<style lang="scss">
.auth-no-data {
    height: 100%;
    .description {
        font-size: 16px;
    }
}
</style>
